import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getProduct } from '../../utils/tracking';

export function trackEstimateClick(offer: IOfferSchema, agent: IAgentSchema | null) {
  const product = getProduct(offer, agent);

  ca('eventSite', {
    action: 'bti_click',
    category: 'card',
    label: 'estimate_button',
    name: 'oldevent',
    products: [{ ...product }],
  });
}

export function trackChartTooltipShow(offer: IOfferSchema, agent: IAgentSchema | null) {
  const product = getProduct(offer, agent);

  ca('eventSite', {
    action: 'bti_click',
    category: 'card',
    label: 'graph_tooltip',
    name: 'oldevent',
    products: [{ ...product }],
  });
}

export function trackCostEstimateVisible() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'Scroll',
    label: 'estimate_block',
    useLastProducts: true,
  });
}
